import { render } from "./leads.vue?vue&type=template&id=bfa3d16c"
import script from "./leads.vue?vue&type=script&lang=js"
export * from "./leads.vue?vue&type=script&lang=js"

import "./leads.vue?vue&type=style&index=0&id=bfa3d16c&lang=css"
import "./leads.vue?vue&type=style&index=1&id=bfa3d16c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__